import { http } from '../helpers/http'
import { buildFindAllUrl } from './shared.service'

const findAll = (filters) => {
  let url = '/events'
  if (filters) {
    url = buildFindAllUrl(url, filters)
  }
  return http.get(url)
}

const find = (id) => {
  return http.get(`/event/${id}`)
}

const findAllParents = (eventId) => {
  if (eventId) {
    return http.get('/events/available-parents', {
      params: {
        excludedEventId: eventId
      }
    })
  }

  return http.get('/events/available-parents')
}

const findChildren = ({ eventId, filters, ...params }) => {
  params.filters = JSON.stringify(filters)
  return http.get(`/event/${eventId}/children`, { params })
}

const findAvailableChildren = (id) => {
  return http.get(`/event/${id}/available-children`)
}

const create = (event) => {
  const cleanEvent = {
    nature: event.nature.id || null,
    recipient:
      (event.recipient !== null && event.recipient.id !== 'other'
        ? event.recipient.id
        : null) || null,
    origin:
      (event.origin !== null && event.origin.id !== 'other'
        ? event.origin.id
        : null) || null,
    parent: (event.parent !== null ? event.parent.id : null) || null,
    label: event.label,
    startingDate: event.startingDate || null,
    endingDate: event.endingDate || null,
    coordinates: event.coordinates || null,
    otherOrigin: event.otherOrigin || null,
    otherRecipient: event.otherRecipient || null,
    description: event.description || null,
    moreInformation: event.moreInformation || null
  }
  return http.post('/events', cleanEvent)
}

const update = (id, event) => {
  const cleanEvent = {
    nature: event.nature.id || null,
    recipient:
      (event.recipient.id !== 'other' ? event.recipient.id : null) || null,
    origin: (event.origin.id !== 'other' ? event.origin.id : null) || null,
    parent: event.parent.id || null,
    label: event.label,
    startingDate: event.startingDate || null,
    endingDate: event.endingDate || null,
    coordinates: event.coordinates || null,
    otherOrigin: event.otherOrigin || null,
    otherRecipient: event.otherRecipient || null,
    description: event.description || null,
    moreInformation: event.moreInformation || null
  }
  return http.patch(`/event/${id}`, cleanEvent)
}

const updatePart = (id, updatePart) => {
  return http.patch(`/event/${id}`, updatePart)
}

const deleteEvent = (id) => {
  return http.delete(`/event/${id}`)
}

const removeFile = (fileId) => {
  return http.delete(`/attachment/${fileId}`)
}

const findHistory = (id) => {
  return http.get(`/event/${id}/history`)
}

const exportEvent = (eventId, mapUrl, format, type) => {
  console.log('PRINTED', { eventId, mapUrl, format, type })
  const headers = {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf'
    }
  }

  if (type === 'Export unitaire') {
    return http.post(
      `/event/${eventId}/export`,
      {
        printUrl: mapUrl,
        format
      },
      headers
    )
  }

  if (type === 'Export complet') {
    return http.post(
      `/event/${eventId}/export/full`,
      {
        printUrl: mapUrl,
        format
      },
      headers
    )
  }
}

const duplicateEvent = (eventId, duplicatedDate) => {
  return http.post(`/event/${eventId}/duplicate`, {
    dateEvent: duplicatedDate
  })
}

export const eventService = {
  findAll,
  find,
  findAllParents,
  findChildren,
  create,
  update,
  findAvailableChildren,
  updatePart,
  removeFile,
  deleteEvent,
  findHistory,
  exportEvent,
  duplicateEvent
}
